import { TrophyOutlined } from "@ant-design/icons";
import { ResourceProps } from "@refinedev/core";

export const awardTypesResource: ResourceProps = {
  name: "award-types",
  meta: {
    icon: <TrophyOutlined />,
    label: "Типы наград",
  },
  list: "/award-types",
  create: "/award-types/create",
  show: "/award-types/:id",
};
